/* Product-description videos only. Native Parallax owns the gallery and commerce. */
(() => {
  if (window.__drDownriggerVideosBound) return;
  window.__drDownriggerVideosBound = true;
  document.addEventListener('click', (event) => {
    const play = event.target.closest('[data-dr-downrigger] [data-drp-video]');
    if (!play) return;
    const id = play.dataset.drpVideo;
    if (!/^[A-Za-z0-9_-]{11}$/.test(id)) return;
    const stage = play.closest('.drp-video-stage');
    if (!stage || stage.querySelector('iframe')) return;
    const frame = document.createElement('iframe');
    frame.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
    frame.title = play.dataset.title || 'Downrigging demonstration';
    frame.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen';
    frame.allowFullscreen = true;
    frame.referrerPolicy = 'strict-origin-when-cross-origin';
    stage.replaceChildren(frame);
    frame.focus();
  });
})();